/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import RouterService from '@ember/routing/router-service';
import CampaignModel from 'cio/models/campaign';

interface CreateEventEditorEventLoopWarningArgs {
  source: string;
  campaign: CampaignModel;
}

export default class CreateEventEditorEventLoopWarning extends Component<CreateEventEditorEventLoopWarningArgs> {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;

  campaignTriggerLoopTitle = 'Your conditions will trigger this campaign again';

  constructor(owner: unknown, args: CreateEventEditorEventLoopWarningArgs) {
    super(owner, args);

    this.analytics.track('user', 'error_encountered', {
      currentUrl: this.router.currentURL,
      message: this.campaignTriggerLoopTitle,
      source: this.args.source,
    });
  }
}
